module.exports = __webpack_public_path__ + "static/media/node-js-logo-cropped.e266e8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/node-js-logo-cropped.png
// module id = 63
// module chunks = 0